let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("6o8th")).then(() => parcelRequire('78yGu'));